//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface ISimulateClient {
    /**
     * Buscar productos con filtros y paginación
     * @param specsColorin (optional) Spec IN (OR por valores). Ej: specs[Color][in]=Negro,Blanco
     * @param specsColor (optional) Spec exacta (AND). Podés enviar múltiples: specs[Color]=Negro&specs[Talla]=XS
     * @param includeOutOfStock (optional) 
     * @param includeFacets (optional) 
     * @param maxPrice (optional) 
     * @param minPrice (optional) 
     * @param productIds (optional) 
     * @param collectionId (optional) 
     * @param brandIds (optional) 
     * @param categoryExternalIds (optional) 
     * @param categoryIds (optional) 
     * @param q (optional) Texto libre: nombre, descripción, SEO, keywords...
     * @param sort (optional) Criterios: propiedad_(asc|desc). Ej: name_asc, price_desc, score_desc, releaseDate_desc, discount_desc
     * @param size (optional) Cantidad de elementos por página
     * @param page (optional) Índice de página (inicia en 0)
     */
    searchProducts(specsColorin?: string | undefined, specsColor?: string | undefined, includeOutOfStock?: boolean | undefined, includeFacets?: boolean | undefined, maxPrice?: number | undefined, minPrice?: number | undefined, productIds?: string[] | undefined, collectionId?: string | undefined, brandIds?: string[] | undefined, categoryExternalIds?: string[] | undefined, categoryIds?: string[] | undefined, q?: string | undefined, sort?: string[] | undefined, size?: number | undefined, page?: number | undefined): Observable<ProductSearchResponseV3Dto>;
    /**
     * Simular búsqueda de productos y obtener traza completa de diagnóstico
     * @param q Término de búsqueda (requerido). Define la búsqueda de texto en el índice.
     * @param page (optional) Índice de página a explicar (inicia en 0).
     * @param size (optional) Cantidad de resultados a explicar. El micro lo recorta a un máximo de 20.
     */
    simulateSearchProducts(q: string, page?: number | undefined, size?: number | undefined): Observable<ProductSimulateSearchResponseDto>;
}

@Injectable({
    providedIn: 'root'
})
export class SimulateClient implements ISimulateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Buscar productos con filtros y paginación
     * @param specsColorin (optional) Spec IN (OR por valores). Ej: specs[Color][in]=Negro,Blanco
     * @param specsColor (optional) Spec exacta (AND). Podés enviar múltiples: specs[Color]=Negro&specs[Talla]=XS
     * @param includeOutOfStock (optional) 
     * @param includeFacets (optional) 
     * @param maxPrice (optional) 
     * @param minPrice (optional) 
     * @param productIds (optional) 
     * @param collectionId (optional) 
     * @param brandIds (optional) 
     * @param categoryExternalIds (optional) 
     * @param categoryIds (optional) 
     * @param q (optional) Texto libre: nombre, descripción, SEO, keywords...
     * @param sort (optional) Criterios: propiedad_(asc|desc). Ej: name_asc, price_desc, score_desc, releaseDate_desc, discount_desc
     * @param size (optional) Cantidad de elementos por página
     * @param page (optional) Índice de página (inicia en 0)
     */
    searchProducts(specsColorin?: string | undefined, specsColor?: string | undefined, includeOutOfStock?: boolean | undefined, includeFacets?: boolean | undefined, maxPrice?: number | undefined, minPrice?: number | undefined, productIds?: string[] | undefined, collectionId?: string | undefined, brandIds?: string[] | undefined, categoryExternalIds?: string[] | undefined, categoryIds?: string[] | undefined, q?: string | undefined, sort?: string[] | undefined, size?: number | undefined, page?: number | undefined): Observable<ProductSearchResponseV3Dto> {
        let url_ = this.baseUrl + "/hub/management/query/v3/products?";
        if (specsColorin === null)
            throw new globalThis.Error("The parameter 'specsColorin' cannot be null.");
        else if (specsColorin !== undefined)
            url_ += "specs[Color][in]=" + encodeURIComponent("" + specsColorin) + "&";
        if (specsColor === null)
            throw new globalThis.Error("The parameter 'specsColor' cannot be null.");
        else if (specsColor !== undefined)
            url_ += "specs[Color]=" + encodeURIComponent("" + specsColor) + "&";
        if (includeOutOfStock === null)
            throw new globalThis.Error("The parameter 'includeOutOfStock' cannot be null.");
        else if (includeOutOfStock !== undefined)
            url_ += "includeOutOfStock=" + encodeURIComponent("" + includeOutOfStock) + "&";
        if (includeFacets === null)
            throw new globalThis.Error("The parameter 'includeFacets' cannot be null.");
        else if (includeFacets !== undefined)
            url_ += "includeFacets=" + encodeURIComponent("" + includeFacets) + "&";
        if (maxPrice === null)
            throw new globalThis.Error("The parameter 'maxPrice' cannot be null.");
        else if (maxPrice !== undefined)
            url_ += "maxPrice=" + encodeURIComponent("" + maxPrice) + "&";
        if (minPrice === null)
            throw new globalThis.Error("The parameter 'minPrice' cannot be null.");
        else if (minPrice !== undefined)
            url_ += "minPrice=" + encodeURIComponent("" + minPrice) + "&";
        if (productIds === null)
            throw new globalThis.Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "productIds=" + encodeURIComponent("" + item) + "&"; });
        if (collectionId === null)
            throw new globalThis.Error("The parameter 'collectionId' cannot be null.");
        else if (collectionId !== undefined)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        if (brandIds === null)
            throw new globalThis.Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "brandIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryExternalIds === null)
            throw new globalThis.Error("The parameter 'categoryExternalIds' cannot be null.");
        else if (categoryExternalIds !== undefined)
            categoryExternalIds && categoryExternalIds.forEach(item => { url_ += "categoryExternalIds=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIds === null)
            throw new globalThis.Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (sort === null)
            throw new globalThis.Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSearchResponseV3Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSearchResponseV3Dto>;
        }));
    }

    protected processSearchProducts(response: HttpResponseBase): Observable<ProductSearchResponseV3Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductSearchResponseV3Dto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Simular búsqueda de productos y obtener traza completa de diagnóstico
     * @param q Término de búsqueda (requerido). Define la búsqueda de texto en el índice.
     * @param page (optional) Índice de página a explicar (inicia en 0).
     * @param size (optional) Cantidad de resultados a explicar. El micro lo recorta a un máximo de 20.
     */
    simulateSearchProducts(q: string, page?: number | undefined, size?: number | undefined): Observable<ProductSimulateSearchResponseDto> {
        let url_ = this.baseUrl + "/hub/management/query/v3/simulate/products?";
        if (q === undefined || q === null)
            throw new globalThis.Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSimulateSearchProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSimulateSearchProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSimulateSearchResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSimulateSearchResponseDto>;
        }));
    }

    protected processSimulateSearchProducts(response: HttpResponseBase): Observable<ProductSimulateSearchResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductSimulateSearchResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ProductSearchResponseV3Dto implements IProductSearchResponseV3Dto {
    page!: ProductSearchPageDto;
    items!: ProductItemV3Dto[];
    /** Facets de búsqueda (cuando includeFacets=true) */
    facets?: any;

    [key: string]: any;

    constructor(data?: IProductSearchResponseV3Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.page = new ProductSearchPageDto();
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"] ? ProductSearchPageDto.fromJS(_data["page"]) : new ProductSearchPageDto();
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProductItemV3Dto.fromJS(item));
            }
            this.facets = _data["facets"];
        }
    }

    static fromJS(data: any): ProductSearchResponseV3Dto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSearchResponseV3Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page ? this.page.toJSON() : undefined as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["facets"] = this.facets;
        return data;
    }
}

export interface IProductSearchResponseV3Dto {
    page: ProductSearchPageDto;
    items: ProductItemV3Dto[];
    /** Facets de búsqueda (cuando includeFacets=true) */
    facets?: any;

    [key: string]: any;
}

export class ProductSimulateSearchResponseDto implements IProductSimulateSearchResponseDto {
    /** Parámetros efectivamente aplicados */
    request!: SimulateSearchRequestDto;
    /** Campos del índice sobre los que corrió el match de texto */
    searchFields!: SearchFieldDto[];
    /** Reglas de negocio de la búsqueda (redirección, merchandising, relevancia y sinónimos) */
    rules!: SimulationRulesDto;
    /** Cantidad total de productos que coincidieron con la búsqueda */
    totalElements!: number;
    /** Lista de productos explicados en el orden resultante */
    results!: ProductResultDto[];

    [key: string]: any;

    constructor(data?: IProductSimulateSearchResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.request = new SimulateSearchRequestDto();
            this.searchFields = [];
            this.rules = new SimulationRulesDto();
            this.results = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.request = _data["request"] ? SimulateSearchRequestDto.fromJS(_data["request"]) : new SimulateSearchRequestDto();
            if (Array.isArray(_data["searchFields"])) {
                this.searchFields = [] as any;
                for (let item of _data["searchFields"])
                    this.searchFields!.push(SearchFieldDto.fromJS(item));
            }
            this.rules = _data["rules"] ? SimulationRulesDto.fromJS(_data["rules"]) : new SimulationRulesDto();
            this.totalElements = _data["totalElements"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProductResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductSimulateSearchResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSimulateSearchResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["request"] = this.request ? this.request.toJSON() : undefined as any;
        if (Array.isArray(this.searchFields)) {
            data["searchFields"] = [];
            for (let item of this.searchFields)
                data["searchFields"].push(item ? item.toJSON() : undefined as any);
        }
        data["rules"] = this.rules ? this.rules.toJSON() : undefined as any;
        data["totalElements"] = this.totalElements;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductSimulateSearchResponseDto {
    /** Parámetros efectivamente aplicados */
    request: SimulateSearchRequestDto;
    /** Campos del índice sobre los que corrió el match de texto */
    searchFields: SearchFieldDto[];
    /** Reglas de negocio de la búsqueda (redirección, merchandising, relevancia y sinónimos) */
    rules: SimulationRulesDto;
    /** Cantidad total de productos que coincidieron con la búsqueda */
    totalElements: number;
    /** Lista de productos explicados en el orden resultante */
    results: ProductResultDto[];

    [key: string]: any;
}

export class ProductSearchPageDto implements IProductSearchPageDto {
    number!: number;
    size!: number;
    totalElements!: number;
    totalPages!: number;
    empty!: boolean;

    [key: string]: any;

    constructor(data?: IProductSearchPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.number = _data["number"];
            this.size = _data["size"];
            this.totalElements = _data["totalElements"];
            this.totalPages = _data["totalPages"];
            this.empty = _data["empty"];
        }
    }

    static fromJS(data: any): ProductSearchPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSearchPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["number"] = this.number;
        data["size"] = this.size;
        data["totalElements"] = this.totalElements;
        data["totalPages"] = this.totalPages;
        data["empty"] = this.empty;
        return data;
    }
}

export interface IProductSearchPageDto {
    number: number;
    size: number;
    totalElements: number;
    totalPages: number;
    empty: boolean;

    [key: string]: any;
}

export class ProductItemV3Dto implements IProductItemV3Dto {
    productId!: string;
    productRefId?: string;
    name!: string;
    description?: string;
    brand?: BrandDto;
    category?: CategoryDto;
    seo?: SeoInfoDto;
    collections?: CollectionInfoDto[];
    releaseDate?: string;
    /** Especificaciones dinámicas del producto (key/value). */
    specification?: { [key: string]: string; };
    skus!: ProductSkuDto[];

    [key: string]: any;

    constructor(data?: IProductItemV3Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.skus = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.productId = _data["productId"];
            this.productRefId = _data["productRefId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.brand = _data["brand"] ? BrandDto.fromJS(_data["brand"]) : undefined as any;
            this.category = _data["category"] ? CategoryDto.fromJS(_data["category"]) : undefined as any;
            this.seo = _data["seo"] ? SeoInfoDto.fromJS(_data["seo"]) : undefined as any;
            if (Array.isArray(_data["collections"])) {
                this.collections = [] as any;
                for (let item of _data["collections"])
                    this.collections!.push(CollectionInfoDto.fromJS(item));
            }
            this.releaseDate = _data["releaseDate"];
            if (_data["specification"]) {
                this.specification = {} as any;
                for (let key in _data["specification"]) {
                    if (_data["specification"].hasOwnProperty(key))
                        (this.specification as any)![key] = _data["specification"][key];
                }
            }
            if (Array.isArray(_data["skus"])) {
                this.skus = [] as any;
                for (let item of _data["skus"])
                    this.skus!.push(ProductSkuDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductItemV3Dto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductItemV3Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["productId"] = this.productId;
        data["productRefId"] = this.productRefId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["brand"] = this.brand ? this.brand.toJSON() : undefined as any;
        data["category"] = this.category ? this.category.toJSON() : undefined as any;
        data["seo"] = this.seo ? this.seo.toJSON() : undefined as any;
        if (Array.isArray(this.collections)) {
            data["collections"] = [];
            for (let item of this.collections)
                data["collections"].push(item ? item.toJSON() : undefined as any);
        }
        data["releaseDate"] = this.releaseDate;
        if (this.specification) {
            data["specification"] = {};
            for (let key in this.specification) {
                if (this.specification.hasOwnProperty(key))
                    (data["specification"] as any)[key] = (this.specification as any)[key];
            }
        }
        if (Array.isArray(this.skus)) {
            data["skus"] = [];
            for (let item of this.skus)
                data["skus"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductItemV3Dto {
    productId: string;
    productRefId?: string;
    name: string;
    description?: string;
    brand?: BrandDto;
    category?: CategoryDto;
    seo?: SeoInfoDto;
    collections?: CollectionInfoDto[];
    releaseDate?: string;
    /** Especificaciones dinámicas del producto (key/value). */
    specification?: { [key: string]: string; };
    skus: ProductSkuDto[];

    [key: string]: any;
}

export class SimulateSearchRequestDto implements ISimulateSearchRequestDto {
    /** Término de búsqueda */
    q!: string;
    /** Tienda */
    storeId!: string;
    /** Cantidad de resultados efectivamente explicados (recortado a máximo 20) */
    size!: number;
    /** Índice de página explicado (inicia en 0) */
    page!: number;

    [key: string]: any;

    constructor(data?: ISimulateSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.q = _data["q"];
            this.storeId = _data["storeId"];
            this.size = _data["size"];
            this.page = _data["page"];
        }
    }

    static fromJS(data: any): SimulateSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulateSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["q"] = this.q;
        data["storeId"] = this.storeId;
        data["size"] = this.size;
        data["page"] = this.page;
        return data;
    }
}

export interface ISimulateSearchRequestDto {
    /** Término de búsqueda */
    q: string;
    /** Tienda */
    storeId: string;
    /** Cantidad de resultados efectivamente explicados (recortado a máximo 20) */
    size: number;
    /** Índice de página explicado (inicia en 0) */
    page: number;

    [key: string]: any;
}

export class SearchFieldDto implements ISearchFieldDto {
    /** Ruta del atributo en el índice */
    field!: string;
    /** Tipo de match */
    type!: string;
    /** Estructura anidada que envuelve al campo, o vacío si es de primer nivel */
    nestedPath?: string;
    /** Si el match aplica el analizador configurado para la tienda */
    useStoreAnalyzer?: boolean;
    /** Estrategias de match con sus boosts */
    strategies!: SearchFieldStrategyDto[];

    [key: string]: any;

    constructor(data?: ISearchFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.strategies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.field = _data["field"];
            this.type = _data["type"];
            this.nestedPath = _data["nestedPath"];
            this.useStoreAnalyzer = _data["useStoreAnalyzer"];
            if (Array.isArray(_data["strategies"])) {
                this.strategies = [] as any;
                for (let item of _data["strategies"])
                    this.strategies!.push(SearchFieldStrategyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["field"] = this.field;
        data["type"] = this.type;
        data["nestedPath"] = this.nestedPath;
        data["useStoreAnalyzer"] = this.useStoreAnalyzer;
        if (Array.isArray(this.strategies)) {
            data["strategies"] = [];
            for (let item of this.strategies)
                data["strategies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearchFieldDto {
    /** Ruta del atributo en el índice */
    field: string;
    /** Tipo de match */
    type: string;
    /** Estructura anidada que envuelve al campo, o vacío si es de primer nivel */
    nestedPath?: string;
    /** Si el match aplica el analizador configurado para la tienda */
    useStoreAnalyzer?: boolean;
    /** Estrategias de match con sus boosts */
    strategies: SearchFieldStrategyDto[];

    [key: string]: any;
}

export class SimulationRulesDto implements ISimulationRulesDto {
    /** Redirección */
    redirect!: SimulationRedirectDto;
    /** Reglas de merchandising que aplicaron */
    merchandising!: SimulationMerchandisingRuleDto[];
    /** Relevancia */
    relevance!: SimulationRelevanceDto;
    /** Sinónimos */
    synonyms!: SimulationSynonymsDto;

    [key: string]: any;

    constructor(data?: ISimulationRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.redirect = new SimulationRedirectDto();
            this.merchandising = [];
            this.relevance = new SimulationRelevanceDto();
            this.synonyms = new SimulationSynonymsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.redirect = _data["redirect"] ? SimulationRedirectDto.fromJS(_data["redirect"]) : new SimulationRedirectDto();
            if (Array.isArray(_data["merchandising"])) {
                this.merchandising = [] as any;
                for (let item of _data["merchandising"])
                    this.merchandising!.push(SimulationMerchandisingRuleDto.fromJS(item));
            }
            this.relevance = _data["relevance"] ? SimulationRelevanceDto.fromJS(_data["relevance"]) : new SimulationRelevanceDto();
            this.synonyms = _data["synonyms"] ? SimulationSynonymsDto.fromJS(_data["synonyms"]) : new SimulationSynonymsDto();
        }
    }

    static fromJS(data: any): SimulationRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["redirect"] = this.redirect ? this.redirect.toJSON() : undefined as any;
        if (Array.isArray(this.merchandising)) {
            data["merchandising"] = [];
            for (let item of this.merchandising)
                data["merchandising"].push(item ? item.toJSON() : undefined as any);
        }
        data["relevance"] = this.relevance ? this.relevance.toJSON() : undefined as any;
        data["synonyms"] = this.synonyms ? this.synonyms.toJSON() : undefined as any;
        return data;
    }
}

export interface ISimulationRulesDto {
    /** Redirección */
    redirect: SimulationRedirectDto;
    /** Reglas de merchandising que aplicaron */
    merchandising: SimulationMerchandisingRuleDto[];
    /** Relevancia */
    relevance: SimulationRelevanceDto;
    /** Sinónimos */
    synonyms: SimulationSynonymsDto;

    [key: string]: any;
}

export class ProductResultDto implements IProductResultDto {
    /** Posición en el resultado, comenzando en 1 */
    rank!: number;
    /** Identificador del producto */
    productId!: string;
    /** Nombre del producto */
    name!: string;
    /** Marca del producto */
    brand?: string;
    /** URL de la primera imagen del primer SKU */
    imageUrl?: string;
    /** Score calculado por el motor de búsqueda para esta consulta */
    score!: number;
    /** Score indexado del producto (independiente del término) */
    catalogScore?: number;
    /** Cantidad de ventas indexada */
    salesCount?: number;
    /** Cantidad de vistas indexada */
    viewsCount?: number;
    /** Descuento indexado usado para ordenamiento */
    sortDiscount?: number;
    /** Fecha de lanzamiento indexada */
    releaseDate?: string;

    [key: string]: any;

    constructor(data?: IProductResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.rank = _data["rank"];
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.brand = _data["brand"];
            this.imageUrl = _data["imageUrl"];
            this.score = _data["score"];
            this.catalogScore = _data["catalogScore"];
            this.salesCount = _data["salesCount"];
            this.viewsCount = _data["viewsCount"];
            this.sortDiscount = _data["sortDiscount"];
            this.releaseDate = _data["releaseDate"];
        }
    }

    static fromJS(data: any): ProductResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["rank"] = this.rank;
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["brand"] = this.brand;
        data["imageUrl"] = this.imageUrl;
        data["score"] = this.score;
        data["catalogScore"] = this.catalogScore;
        data["salesCount"] = this.salesCount;
        data["viewsCount"] = this.viewsCount;
        data["sortDiscount"] = this.sortDiscount;
        data["releaseDate"] = this.releaseDate;
        return data;
    }
}

export interface IProductResultDto {
    /** Posición en el resultado, comenzando en 1 */
    rank: number;
    /** Identificador del producto */
    productId: string;
    /** Nombre del producto */
    name: string;
    /** Marca del producto */
    brand?: string;
    /** URL de la primera imagen del primer SKU */
    imageUrl?: string;
    /** Score calculado por el motor de búsqueda para esta consulta */
    score: number;
    /** Score indexado del producto (independiente del término) */
    catalogScore?: number;
    /** Cantidad de ventas indexada */
    salesCount?: number;
    /** Cantidad de vistas indexada */
    viewsCount?: number;
    /** Descuento indexado usado para ordenamiento */
    sortDiscount?: number;
    /** Fecha de lanzamiento indexada */
    releaseDate?: string;

    [key: string]: any;
}

export class BrandDto implements IBrandDto {
    /** ID de la marca */
    id!: string;
    /** Nombre de la marca */
    name!: string;
    /** Términos de búsqueda alternativos */
    keywords!: string;
    /** Breve descripción de la marca, mostrada por los motores de búsqueda */
    metaDescription!: string;
    /** Meta título para la página de la marca */
    metaTitle!: string;
    /** Relevancia de la marca */
    score!: number;
    /** URL amigable identifica la marca en el sistema web */
    permalink!: string;
    status!: string;
    /** ID externo de la marca */
    externalId!: string;

    [key: string]: any;

    constructor(data?: IBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.keywords = _data["keywords"];
            this.metaDescription = _data["metaDescription"];
            this.metaTitle = _data["metaTitle"];
            this.score = _data["score"];
            this.permalink = _data["permalink"];
            this.status = _data["status"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): BrandDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["keywords"] = this.keywords;
        data["metaDescription"] = this.metaDescription;
        data["metaTitle"] = this.metaTitle;
        data["score"] = this.score;
        data["permalink"] = this.permalink;
        data["status"] = this.status;
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IBrandDto {
    /** ID de la marca */
    id: string;
    /** Nombre de la marca */
    name: string;
    /** Términos de búsqueda alternativos */
    keywords: string;
    /** Breve descripción de la marca, mostrada por los motores de búsqueda */
    metaDescription: string;
    /** Meta título para la página de la marca */
    metaTitle: string;
    /** Relevancia de la marca */
    score: number;
    /** URL amigable identifica la marca en el sistema web */
    permalink: string;
    status: string;
    /** ID externo de la marca */
    externalId: string;

    [key: string]: any;
}

export class CategoryDto implements ICategoryDto {
    id!: string;
    name!: string;
    externalId?: string;
    shortName?: string;
    description?: string;
    colorHex?: string;
    imageUrl?: string;
    imageAltText?: string | undefined;
    keywords?: string;
    permalink?: string;
    metaTitle?: string;
    metaDescription?: string;
    deepLinkDescription?: string;
    childrenCount?: number;
    level?: number;
    productsCount?: number;
    parent?: CategoryParentDto | undefined;
    status?: CategoryDtoStatus;
    score?: number | undefined;
    /** Ruta completa desde la raíz hasta esta categoría, en orden e INCLUYENDO a la categoría misma como último elemento. Solo viene poblado en el detalle (GET /categories/{id}); el listado no lo trae. */
    path?: CategoryPathItemDto[];

    [key: string]: any;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.colorHex = _data["colorHex"];
            this.imageUrl = _data["imageUrl"];
            this.imageAltText = _data["imageAltText"];
            this.keywords = _data["keywords"];
            this.permalink = _data["permalink"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.deepLinkDescription = _data["deepLinkDescription"];
            this.childrenCount = _data["childrenCount"];
            this.level = _data["level"];
            this.productsCount = _data["productsCount"];
            this.parent = _data["parent"] ? CategoryParentDto.fromJS(_data["parent"]) : undefined as any;
            this.status = _data["status"];
            this.score = _data["score"];
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(CategoryPathItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["colorHex"] = this.colorHex;
        data["imageUrl"] = this.imageUrl;
        data["imageAltText"] = this.imageAltText;
        data["keywords"] = this.keywords;
        data["permalink"] = this.permalink;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["deepLinkDescription"] = this.deepLinkDescription;
        data["childrenCount"] = this.childrenCount;
        data["level"] = this.level;
        data["productsCount"] = this.productsCount;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["status"] = this.status;
        data["score"] = this.score;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICategoryDto {
    id: string;
    name: string;
    externalId?: string;
    shortName?: string;
    description?: string;
    colorHex?: string;
    imageUrl?: string;
    imageAltText?: string | undefined;
    keywords?: string;
    permalink?: string;
    metaTitle?: string;
    metaDescription?: string;
    deepLinkDescription?: string;
    childrenCount?: number;
    level?: number;
    productsCount?: number;
    parent?: CategoryParentDto | undefined;
    status?: CategoryDtoStatus;
    score?: number | undefined;
    /** Ruta completa desde la raíz hasta esta categoría, en orden e INCLUYENDO a la categoría misma como último elemento. Solo viene poblado en el detalle (GET /categories/{id}); el listado no lo trae. */
    path?: CategoryPathItemDto[];

    [key: string]: any;
}

export class SeoInfoDto implements ISeoInfoDto {
    permalink?: string;
    metaTitle?: string;
    metaDescription?: string;
    keywords?: string;

    [key: string]: any;

    constructor(data?: ISeoInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.permalink = _data["permalink"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.keywords = _data["keywords"];
        }
    }

    static fromJS(data: any): SeoInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeoInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["permalink"] = this.permalink;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["keywords"] = this.keywords;
        return data;
    }
}

export interface ISeoInfoDto {
    permalink?: string;
    metaTitle?: string;
    metaDescription?: string;
    keywords?: string;

    [key: string]: any;
}

export class CollectionInfoDto implements ICollectionInfoDto {
    id!: string;
    name!: string;
    isFeatured?: boolean;
    type?: string;
    permalink?: string;

    [key: string]: any;

    constructor(data?: ICollectionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.isFeatured = _data["isFeatured"];
            this.type = _data["type"];
            this.permalink = _data["permalink"];
        }
    }

    static fromJS(data: any): CollectionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["isFeatured"] = this.isFeatured;
        data["type"] = this.type;
        data["permalink"] = this.permalink;
        return data;
    }
}

export interface ICollectionInfoDto {
    id: string;
    name: string;
    isFeatured?: boolean;
    type?: string;
    permalink?: string;

    [key: string]: any;
}

export class ProductSkuDto implements IProductSkuDto {
    skuId!: string;
    skuRefId?: string;
    name!: string;
    ean?: string;
    images?: SkuImageDto[];
    seller?: SellerDto;
    sellers?: SellerDto[];

    [key: string]: any;

    constructor(data?: IProductSkuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.skuId = _data["skuId"];
            this.skuRefId = _data["skuRefId"];
            this.name = _data["name"];
            this.ean = _data["ean"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(SkuImageDto.fromJS(item));
            }
            this.seller = _data["seller"] ? SellerDto.fromJS(_data["seller"]) : undefined as any;
            if (Array.isArray(_data["sellers"])) {
                this.sellers = [] as any;
                for (let item of _data["sellers"])
                    this.sellers!.push(SellerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductSkuDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSkuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["skuId"] = this.skuId;
        data["skuRefId"] = this.skuRefId;
        data["name"] = this.name;
        data["ean"] = this.ean;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["seller"] = this.seller ? this.seller.toJSON() : undefined as any;
        if (Array.isArray(this.sellers)) {
            data["sellers"] = [];
            for (let item of this.sellers)
                data["sellers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductSkuDto {
    skuId: string;
    skuRefId?: string;
    name: string;
    ean?: string;
    images?: SkuImageDto[];
    seller?: SellerDto;
    sellers?: SellerDto[];

    [key: string]: any;
}

export class SearchFieldStrategyDto implements ISearchFieldStrategyDto {
    /** Tipo de match (MATCH, KEYWORD, etc.) */
    type!: string;
    /** Boost aplicado al campo */
    boost!: number;
    /** Si aplica tolerancia a errores de tipeo (fuzzy matching) */
    fuzziness?: string;
    /** Indica si hubo error al parsear la estrategia desde el formato de string. Cuando es true, el boost puede ser el valor por defecto 1.0. */
    parseError?: boolean;

    [key: string]: any;

    constructor(data?: ISearchFieldStrategyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.boost = _data["boost"];
            this.fuzziness = _data["fuzziness"];
            this.parseError = _data["parseError"];
        }
    }

    static fromJS(data: any): SearchFieldStrategyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFieldStrategyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["boost"] = this.boost;
        data["fuzziness"] = this.fuzziness;
        data["parseError"] = this.parseError;
        return data;
    }
}

export interface ISearchFieldStrategyDto {
    /** Tipo de match (MATCH, KEYWORD, etc.) */
    type: string;
    /** Boost aplicado al campo */
    boost: number;
    /** Si aplica tolerancia a errores de tipeo (fuzzy matching) */
    fuzziness?: string;
    /** Indica si hubo error al parsear la estrategia desde el formato de string. Cuando es true, el boost puede ser el valor por defecto 1.0. */
    parseError?: boolean;

    [key: string]: any;
}

export class SimulationRedirectDto implements ISimulationRedirectDto {
    /** Si una regla de redirección aplicó a la búsqueda */
    applied!: boolean;
    /** Identificador de la regla */
    ruleId?: string;
    /** Término que coincidió */
    matchedTerm?: string;
    /** URL de destino */
    url?: string;

    [key: string]: any;

    constructor(data?: ISimulationRedirectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.applied = _data["applied"];
            this.ruleId = _data["ruleId"];
            this.matchedTerm = _data["matchedTerm"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SimulationRedirectDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationRedirectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["applied"] = this.applied;
        data["ruleId"] = this.ruleId;
        data["matchedTerm"] = this.matchedTerm;
        data["url"] = this.url;
        return data;
    }
}

export interface ISimulationRedirectDto {
    /** Si una regla de redirección aplicó a la búsqueda */
    applied: boolean;
    /** Identificador de la regla */
    ruleId?: string;
    /** Término que coincidió */
    matchedTerm?: string;
    /** URL de destino */
    url?: string;

    [key: string]: any;
}

export class SimulationMerchandisingRuleDto implements ISimulationMerchandisingRuleDto {
    /** Identificador de la regla */
    ruleId!: string;
    /** Nombre de la regla */
    name!: string;
    /** Términos de la búsqueda que dispararon la regla */
    matchedTerms!: string[];
    /** Consecuencias aplicadas */
    consequences!: SimulationConsequenceDto[];

    [key: string]: any;

    constructor(data?: ISimulationMerchandisingRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.matchedTerms = [];
            this.consequences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.ruleId = _data["ruleId"];
            this.name = _data["name"];
            if (Array.isArray(_data["matchedTerms"])) {
                this.matchedTerms = [] as any;
                for (let item of _data["matchedTerms"])
                    this.matchedTerms!.push(item);
            }
            if (Array.isArray(_data["consequences"])) {
                this.consequences = [] as any;
                for (let item of _data["consequences"])
                    this.consequences!.push(SimulationConsequenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimulationMerchandisingRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationMerchandisingRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["ruleId"] = this.ruleId;
        data["name"] = this.name;
        if (Array.isArray(this.matchedTerms)) {
            data["matchedTerms"] = [];
            for (let item of this.matchedTerms)
                data["matchedTerms"].push(item);
        }
        if (Array.isArray(this.consequences)) {
            data["consequences"] = [];
            for (let item of this.consequences)
                data["consequences"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISimulationMerchandisingRuleDto {
    /** Identificador de la regla */
    ruleId: string;
    /** Nombre de la regla */
    name: string;
    /** Términos de la búsqueda que dispararon la regla */
    matchedTerms: string[];
    /** Consecuencias aplicadas */
    consequences: SimulationConsequenceDto[];

    [key: string]: any;
}

export class SimulationRelevanceDto implements ISimulationRelevanceDto {
    /** Si los criterios de relevancia participaron del orden */
    applied!: boolean;
    /** APPLIED, EXPLICIT_SORT, NO_STORE_RULE o NO_ACTIVE_CRITERIA */
    reason!: string;
    /** Cómo se compone el _score con las reglas activas */
    composition?: string;
    /** Factor por el que se multiplica el peso de cada criterio */
    boostScale?: number;
    /** Criterios activos */
    criteria!: SimulationRelevanceCriterionDto[];

    [key: string]: any;

    constructor(data?: ISimulationRelevanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.criteria = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.applied = _data["applied"];
            this.reason = _data["reason"];
            this.composition = _data["composition"];
            this.boostScale = _data["boostScale"];
            if (Array.isArray(_data["criteria"])) {
                this.criteria = [] as any;
                for (let item of _data["criteria"])
                    this.criteria!.push(SimulationRelevanceCriterionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimulationRelevanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationRelevanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["applied"] = this.applied;
        data["reason"] = this.reason;
        data["composition"] = this.composition;
        data["boostScale"] = this.boostScale;
        if (Array.isArray(this.criteria)) {
            data["criteria"] = [];
            for (let item of this.criteria)
                data["criteria"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISimulationRelevanceDto {
    /** Si los criterios de relevancia participaron del orden */
    applied: boolean;
    /** APPLIED, EXPLICIT_SORT, NO_STORE_RULE o NO_ACTIVE_CRITERIA */
    reason: string;
    /** Cómo se compone el _score con las reglas activas */
    composition?: string;
    /** Factor por el que se multiplica el peso de cada criterio */
    boostScale?: number;
    /** Criterios activos */
    criteria: SimulationRelevanceCriterionDto[];

    [key: string]: any;
}

export class SimulationSynonymsDto implements ISimulationSynonymsDto {
    /** Si algún término expandió por sinónimos */
    applied!: boolean;
    /** APPLIED, o por qué no hubo expansión: NO_QUERY, NO_STORE_ANALYZER, NO_EXPANSION o ANALYZE_FAILED */
    reason!: string;
    /** Analizador con el que se analizó el texto */
    analyzer?: any | undefined;
    /** Términos que expandieron */
    expansions!: SimulationSynonymExpansionDto[];

    [key: string]: any;

    constructor(data?: ISimulationSynonymsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.expansions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.applied = _data["applied"];
            this.reason = _data["reason"];
            this.analyzer = _data["analyzer"];
            if (Array.isArray(_data["expansions"])) {
                this.expansions = [] as any;
                for (let item of _data["expansions"])
                    this.expansions!.push(SimulationSynonymExpansionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimulationSynonymsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationSynonymsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["applied"] = this.applied;
        data["reason"] = this.reason;
        data["analyzer"] = this.analyzer;
        if (Array.isArray(this.expansions)) {
            data["expansions"] = [];
            for (let item of this.expansions)
                data["expansions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISimulationSynonymsDto {
    /** Si algún término expandió por sinónimos */
    applied: boolean;
    /** APPLIED, o por qué no hubo expansión: NO_QUERY, NO_STORE_ANALYZER, NO_EXPANSION o ANALYZE_FAILED */
    reason: string;
    /** Analizador con el que se analizó el texto */
    analyzer?: any | undefined;
    /** Términos que expandieron */
    expansions: SimulationSynonymExpansionDto[];

    [key: string]: any;
}

export class CategoryParentDto implements ICategoryParentDto {
    id!: string;
    externalId?: string;
    name?: string;

    [key: string]: any;

    constructor(data?: ICategoryParentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CategoryParentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryParentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICategoryParentDto {
    id: string;
    externalId?: string;
    name?: string;

    [key: string]: any;
}

export class CategoryPathItemDto implements ICategoryPathItemDto {
    id!: string;
    name!: string;
    shortName?: string;
    permalink?: string;

    [key: string]: any;

    constructor(data?: ICategoryPathItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.permalink = _data["permalink"];
        }
    }

    static fromJS(data: any): CategoryPathItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryPathItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["permalink"] = this.permalink;
        return data;
    }
}

export interface ICategoryPathItemDto {
    id: string;
    name: string;
    shortName?: string;
    permalink?: string;

    [key: string]: any;
}

export class SkuImageDto implements ISkuImageDto {
    /** ID de la imagen */
    id!: string;
    /** URL pública de la imagen */
    url!: string;
    /** Texto alternativo para accesibilidad */
    altText?: string;
    /** Orden de visualización */
    order?: number;
    /** Fecha de creación */
    createdAt?: string;

    [key: string]: any;

    constructor(data?: ISkuImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.url = _data["url"];
            this.altText = _data["altText"];
            this.order = _data["order"];
            this.createdAt = _data["createdAt"];
        }
    }

    static fromJS(data: any): SkuImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkuImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["url"] = this.url;
        data["altText"] = this.altText;
        data["order"] = this.order;
        data["createdAt"] = this.createdAt;
        return data;
    }
}

export interface ISkuImageDto {
    /** ID de la imagen */
    id: string;
    /** URL pública de la imagen */
    url: string;
    /** Texto alternativo para accesibilidad */
    altText?: string;
    /** Orden de visualización */
    order?: number;
    /** Fecha de creación */
    createdAt?: string;

    [key: string]: any;
}

export class SellerDto implements ISellerDto {
    sellerId!: string;
    sellerName?: string;
    prices!: SellerPriceDto[];
    stock?: SellerStockDto;
    availableUnits?: number;

    [key: string]: any;

    constructor(data?: ISellerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.prices = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.sellerId = _data["sellerId"];
            this.sellerName = _data["sellerName"];
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(SellerPriceDto.fromJS(item));
            }
            this.stock = _data["stock"] ? SellerStockDto.fromJS(_data["stock"]) : undefined as any;
            this.availableUnits = _data["availableUnits"];
        }
    }

    static fromJS(data: any): SellerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["sellerId"] = this.sellerId;
        data["sellerName"] = this.sellerName;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item ? item.toJSON() : undefined as any);
        }
        data["stock"] = this.stock ? this.stock.toJSON() : undefined as any;
        data["availableUnits"] = this.availableUnits;
        return data;
    }
}

export interface ISellerDto {
    sellerId: string;
    sellerName?: string;
    prices: SellerPriceDto[];
    stock?: SellerStockDto;
    availableUnits?: number;

    [key: string]: any;
}

export class SimulationConsequenceDto implements ISimulationConsequenceDto {
    /** Tipo de consecuencia (ADD, REMOVE, PROMOTE, DEMOTE) */
    type!: string;
    /** Operador lógico entre condiciones (AND, OR) */
    logicalOperator?: string;
    /** Peso, en PROMOTE y DEMOTE */
    weight?: number;
    /** Condiciones de la consecuencia */
    conditions!: SimulationConditionDto[];

    [key: string]: any;

    constructor(data?: ISimulationConsequenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.conditions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.logicalOperator = _data["logicalOperator"];
            this.weight = _data["weight"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(SimulationConditionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimulationConsequenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationConsequenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["logicalOperator"] = this.logicalOperator;
        data["weight"] = this.weight;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISimulationConsequenceDto {
    /** Tipo de consecuencia (ADD, REMOVE, PROMOTE, DEMOTE) */
    type: string;
    /** Operador lógico entre condiciones (AND, OR) */
    logicalOperator?: string;
    /** Peso, en PROMOTE y DEMOTE */
    weight?: number;
    /** Condiciones de la consecuencia */
    conditions: SimulationConditionDto[];

    [key: string]: any;
}

export class SimulationRelevanceCriterionDto implements ISimulationRelevanceCriterionDto {
    /** Campo del índice */
    field!: string;
    /** Peso del criterio en la regla */
    weight!: number;
    /** Boost efectivo (peso por el factor de escala) */
    boost?: number;
    /** Función de scoring (field_value_factor, decay, etc.) */
    function?: string;

    [key: string]: any;

    constructor(data?: ISimulationRelevanceCriterionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.field = _data["field"];
            this.weight = _data["weight"];
            this.boost = _data["boost"];
            this.function = _data["function"];
        }
    }

    static fromJS(data: any): SimulationRelevanceCriterionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationRelevanceCriterionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["field"] = this.field;
        data["weight"] = this.weight;
        data["boost"] = this.boost;
        data["function"] = this.function;
        return data;
    }
}

export interface ISimulationRelevanceCriterionDto {
    /** Campo del índice */
    field: string;
    /** Peso del criterio en la regla */
    weight: number;
    /** Boost efectivo (peso por el factor de escala) */
    boost?: number;
    /** Función de scoring (field_value_factor, decay, etc.) */
    function?: string;

    [key: string]: any;
}

export class SimulationSynonymExpansionDto implements ISimulationSynonymExpansionDto {
    /** Término de la búsqueda que expandió */
    term!: string;
    /** Términos que se sumaron a la búsqueda */
    synonyms!: string[];
    /** Regla que produjo la expansión; nula si ninguna regla activa la explica */
    rule?: SimulationSynonymRuleDto | undefined;

    [key: string]: any;

    constructor(data?: ISimulationSynonymExpansionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.synonyms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.term = _data["term"];
            if (Array.isArray(_data["synonyms"])) {
                this.synonyms = [] as any;
                for (let item of _data["synonyms"])
                    this.synonyms!.push(item);
            }
            this.rule = _data["rule"] ? SimulationSynonymRuleDto.fromJS(_data["rule"]) : undefined as any;
        }
    }

    static fromJS(data: any): SimulationSynonymExpansionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationSynonymExpansionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["term"] = this.term;
        if (Array.isArray(this.synonyms)) {
            data["synonyms"] = [];
            for (let item of this.synonyms)
                data["synonyms"].push(item);
        }
        data["rule"] = this.rule ? this.rule.toJSON() : undefined as any;
        return data;
    }
}

export interface ISimulationSynonymExpansionDto {
    /** Término de la búsqueda que expandió */
    term: string;
    /** Términos que se sumaron a la búsqueda */
    synonyms: string[];
    /** Regla que produjo la expansión; nula si ninguna regla activa la explica */
    rule?: SimulationSynonymRuleDto | undefined;

    [key: string]: any;
}

export class SellerPriceDto implements ISellerPriceDto {
    type!: SellerPriceDtoType;
    value!: number;
    promotionCode?: string;
    percentage?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: ISellerPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.value = _data["value"];
            this.promotionCode = _data["promotionCode"];
            this.percentage = _data["percentage"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SellerPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellerPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["value"] = this.value;
        data["promotionCode"] = this.promotionCode;
        data["percentage"] = this.percentage;
        data["name"] = this.name;
        return data;
    }
}

export interface ISellerPriceDto {
    type: SellerPriceDtoType;
    value: number;
    promotionCode?: string;
    percentage?: number;
    name?: string;

    [key: string]: any;
}

export class SellerStockDto implements ISellerStockDto {
    quantity!: number;

    [key: string]: any;

    constructor(data?: ISellerStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): SellerStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellerStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface ISellerStockDto {
    quantity: number;

    [key: string]: any;
}

export class SimulationConditionDto implements ISimulationConditionDto {
    /** Tipo de condición (TERM, BRAND, CATEGORY, SELLER, …) */
    type!: string;
    /** Valor de la condición */
    value!: string;
    /** Operador (IS, CONTAINS) */
    operator!: string;

    [key: string]: any;

    constructor(data?: ISimulationConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.value = _data["value"];
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): SimulationConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["value"] = this.value;
        data["operator"] = this.operator;
        return data;
    }
}

export interface ISimulationConditionDto {
    /** Tipo de condición (TERM, BRAND, CATEGORY, SELLER, …) */
    type: string;
    /** Valor de la condición */
    value: string;
    /** Operador (IS, CONTAINS) */
    operator: string;

    [key: string]: any;
}

export class SimulationSynonymRuleDto implements ISimulationSynonymRuleDto {
    /** Identificador de la regla */
    ruleId!: string;
    /** BIDIRECTIONAL o UNIDIRECTIONAL */
    type!: string;
    /** Términos de entrada de la regla */
    inputTerms!: string[];
    /** Términos destino (solo en UNIDIRECTIONAL) */
    targetTerms!: string[];

    [key: string]: any;

    constructor(data?: ISimulationSynonymRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.inputTerms = [];
            this.targetTerms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.ruleId = _data["ruleId"];
            this.type = _data["type"];
            if (Array.isArray(_data["inputTerms"])) {
                this.inputTerms = [] as any;
                for (let item of _data["inputTerms"])
                    this.inputTerms!.push(item);
            }
            if (Array.isArray(_data["targetTerms"])) {
                this.targetTerms = [] as any;
                for (let item of _data["targetTerms"])
                    this.targetTerms!.push(item);
            }
        }
    }

    static fromJS(data: any): SimulationSynonymRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationSynonymRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["ruleId"] = this.ruleId;
        data["type"] = this.type;
        if (Array.isArray(this.inputTerms)) {
            data["inputTerms"] = [];
            for (let item of this.inputTerms)
                data["inputTerms"].push(item);
        }
        if (Array.isArray(this.targetTerms)) {
            data["targetTerms"] = [];
            for (let item of this.targetTerms)
                data["targetTerms"].push(item);
        }
        return data;
    }
}

export interface ISimulationSynonymRuleDto {
    /** Identificador de la regla */
    ruleId: string;
    /** BIDIRECTIONAL o UNIDIRECTIONAL */
    type: string;
    /** Términos de entrada de la regla */
    inputTerms: string[];
    /** Términos destino (solo en UNIDIRECTIONAL) */
    targetTerms: string[];

    [key: string]: any;
}

export enum CategoryDtoStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum SellerPriceDtoType {
    REGULAR = "REGULAR",
    OFFER = "OFFER",
    PROMOTIONAL = "PROMOTIONAL",
    PROMOTIONAL_GENERAL = "PROMOTIONAL_GENERAL",
    PROMOTIONAL_TC_OH = "PROMOTIONAL_TC_OH",
    PROMOTIONAL_SIP_CREDITO = "PROMOTIONAL_SIP_CREDITO",
    PROMOTIONAL_SIP_DEBITO = "PROMOTIONAL_SIP_DEBITO",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}